<template>
  <el-dialog
    :visible.sync="isShow"
    width="600px"
    :title="isEdit ? '编辑机构场地信息' : '添加机构场地信息'"
    :close-on-click-modal="false"
    custom-class="yioks_alert"
  >
    <el-form
      v-if="!loading"
      ref="squadForm"
      :model="squadInfo"
      :rules="formRules"
      label-width="120px"
      style="height: 500px"
      class="demo-ruleForm">
      <vue-scroll :ops="ops">
        <el-row v-if="!isEdit">
          <el-col :span="20">
            <el-form-item label="管理单位" prop="organUuid">
              <el-select
                v-model.trim="squadInfo.organUuid"
                style="width: 100%"
                placeholder="请选择管理单位"
                @change="changeOrg">
                <el-option
                  v-for="item in selectOrganList"
                  :key="item.organUuid"
                  :value="item.organUuid"
                  :label="item.organShortName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="20">
            <el-form-item label="管理单位" prop="organUuid" >
              <p style="padding-left: 12px">{{squadInfo.organShortName}}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isEdit">
          <el-col :span="20">
            <el-form-item label="精英机构" prop="youthUuid">
              <el-select
                v-model.trim="squadInfo.youthUuid"
                style="width: 100%"
                placeholder="请选择管理单位后再选择精英机构"
                @change="changeCenter(squadInfo.youthUuid)">
                <el-option
                  v-for="item in selectCenterList"
                  :key="item.uuid"
                  :value="item.uuid"
                  :label="item.youthShortName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="20">
            <el-form-item label="精英机构" prop="youthUuid">
              <p style="padding-left: 12px">{{squadInfo.youthShortName}}</p>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="provinceCenter" >
          <div class="label">场地所属区域</div>
          <el-col :span="6">
            <el-form-item label="" label-width="0" prop="cityCode">
              <el-select
                class="w_select"
                v-model="squadInfo.cityCode"
                placeholder="请选择市"
                @change="changeCityForYouthAdd" >
                <el-option
                  v-for="item in cityList"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="" label-width="0" prop="countyCode">
              <el-select
                class="w_select"
                v-model="squadInfo.countyCode"
                placeholder="请选择区"
                @change="changeCountyForYouthAdd" >
                <el-option
                  v-for="item in sh_county_list"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="球场名称" prop="siteName">
              <el-input v-model.trim="squadInfo.siteName" placeholder="请输入球场名称(100个字以内)" maxlength="100"
                show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="球场地址" prop="siteAddress">
              <el-input v-model.trim="squadInfo.siteAddress" placeholder="请输入球场地址(200个字以内)" maxlength="200"
                show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="球场类型" prop="siteType">
              <el-select
                v-model="squadInfo.siteType"
                placeholder="请选择球场类型"
                style="width: 100%">
                <el-option
                  v-for="(item,index) in footballType"
                  :key="index"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="草皮类型" prop="grassType">
              <el-select
                v-model="squadInfo.grassType"
                placeholder="请选择草皮类型"
                style="width: 100%">
                <el-option label="天然草" value="天然草"></el-option>
                <el-option label="人工草" value="人工草"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="球场性质" prop="siteQualityType">
              <el-select
                v-model="squadInfo.siteQualityType"
                placeholder="请选择球场性质"
                style="width: 100%">
                <el-option label="社会培训机构" value="社会培训机构"></el-option>
                <el-option label="社会场地" value="社会场地"></el-option>
                <el-option label="学校场地" value="学校场地"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="建成时间" prop="completeTime">
              <el-date-picker
                v-model="squadInfo.completeTime"
                type="month"
                style="width: 100%"
                placeholder="请选择建成时间"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="产权单位" prop="propertyUnit">
              <el-input v-model.trim="squadInfo.propertyUnit" placeholder="请输入产权单位" maxlength="150"
                show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="产权类型" prop="propertyType">
              <el-select
                v-model="squadInfo.propertyType"
                placeholder="请选择产权类型"
                style="width: 100%"
                >
                <el-option
                  v-for="(item,index) in propertyTypeList"
                  :key="index"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="运营单位" prop="operatingUnit">
              <el-input v-model.trim="squadInfo.operatingUnit" placeholder="请输入运营单位" maxlength="150"
                show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="合同开始时间" prop="cooperationStartDate">
              <el-date-picker
                  v-model="squadInfo.cooperationStartDate"
                  type="month"
                  style="width: 100%"
                  placeholder="请选择合同开始时间"
                  value-format="timestamp"
                :picker-options="StartPickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="合同截止时间" prop="cooperationEndDate">
              <el-date-picker
                  v-model="squadInfo.cooperationEndDate"
                  type="month"
                  style="width: 100%"
                  placeholder="请选择合同截止时间"
                  value-format="timestamp"
                :picker-options="endPickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="相关合同文件" :error="uploadErroeMsg" :rules="{required: true}">
              <el-upload
                class="yioks-form-item"
                :action="uploadPath"
                :on-remove="handleRemoveFile"
                :before-upload="beforeUpload"
                :on-success="handleSuccessFiler"
                multiple
                :limit="9"
                :on-exceed="handleExceed"
                :file-list="uploadFileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <a style="color: #666;">单个上传文件大小不能超过50M,最多上传9个文件。</a>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="使用权限期限" v-if="rest">
              <el-input v-model.number="squadInfo.usePermissions" placeholder="请输入使用权限期限年份 如：1、2…" maxlength="5"
                 style="width: 30%;" :disabled="rest ? true : false"></el-input>
              <span v-if="!rest">年</span>
              <el-checkbox class="rest" v-model="rest" @change="isXiuxi()" style="margin-right:110px">永久</el-checkbox>
            </el-form-item>
            <el-form-item label="使用权限期限" v-else prop="usePermissions">
              <el-input v-model.number="squadInfo.usePermissions" placeholder="请输入使用权限期限年份 如：1、2…" maxlength="5"
                 style="width: 30%;" :disabled="rest ? true : false"></el-input>
              <span v-if="!rest" style="margin-left:10px;margin-right:20px">年</span>
              <el-checkbox class="rest" v-model="rest" @change="isXiuxi()" style="margin-right:110px">永久</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="使用时段" >
              <!--<el-input v-model.trim="squadInfo.useTimePeriod" placeholder="请输入使用时段 如：16:00-20:00/全天" maxlength="200"-->
              <!--show-word-limit></el-input>-->
              <el-time-select placeholder="起始时间" v-model="squadInfo.useTimePeriodStartTime" :picker-options="{
      start: '00:00',
      step: '00:30',
      end: '24:00',
      maxTime: squadInfo.useTimePeriodEndTime
    }" style="width:120px" :disabled="quan ? true : false"></el-time-select>
              <el-time-select placeholder="结束时间" v-model="squadInfo.useTimePeriodEndTime" :picker-options="{
      start: '00:00',
      step: '00:30',
      end: '24:00',
      minTime: squadInfo.useTimePeriodStartTime
    }" style="width:120px" :disabled="quan ? true : false"></el-time-select>
              <el-checkbox class="rest" v-model="quan" @change="quantian()" style="margin-left: 10px;">全天</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="灯光情况" prop="lamplight">
              <el-input v-model.trim="squadInfo.lamplight" placeholder="请输入灯光情况" maxlength="200"
                show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="看台数量" prop="grandstand">
              <el-input v-model.number="squadInfo.grandstand" placeholder="请输入看台数量" maxlength="20"
                ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="附属设施情况">
              <el-input v-model.trim="squadInfo.ancillaryFacilities" placeholder="请输入附属设施情况" maxlength="200"
                show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="备注">
              <el-input v-model.trim="squadInfo.remark" placeholder="请输入备注" maxlength="200"
                show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </vue-scroll>
    </el-form>
    <div v-if="!loading" class="tip">带 * 号的为必填项</div>
    <div v-if="!loading" class="dialog_btn_wrap">
      <el-button
        type="primary"
        style="margin-right:20px"
        :loading="addbtnLoading"
        @click="addSquadCount"
      >确认</el-button>
      <el-button type="danger" @click="isShow = false">取消</el-button>
    </div>
    <yioks-loading v-if="loading" style="height: 500px" />
  </el-dialog>
</template>

<script>
import formRules from '@/utils/formRules/siteFacilities'
import { footballType,propertyTypeList } from '@/utils/yioks_data'
import { squadPlayerSex } from '@/utils/yioks_filter'
import storage from '@/utils/storage'
import { ops } from '@/utils/scrollIndialog'
import siteFacilities from '@/api/siteFacilities'
import coach from '@/api/coach'
import regions from '@/utils/regions'
export default {
  name: 'index',
  components: {
    'UploadImg': () => import('@/components/UploadImg')
  },

  mixins: [formRules],
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    organList: {
      type: Array,
      required: false
    },
    centerList: {
      type: Array,
      required: false
    },
    addSquad: {
      type: Boolean,
      required: true
    },
    squad: {
      type: Object,
      required: false
    },
    squadUuid: {
      type: String,
      required: false
    },
  },
  data () {
    return {
      cityList: [],
      regions,
      img: '',
      uploadPath: "/api/zuxie/guozi/upload/uploadJixiaoFile",
      squadInfo: {
        siteName: '',
        siteAddress: '',
        grassType: '',
        siteQualityType: '',
        completeTime: '',
        youthShortName: '',
        organShortName: '',
        organUuid: '',
        youthUuid: '',
        uuid: '',
        siteType: '',
        cooperationStartDate:'',
        propertyUnit:'',
        propertyType:'',
        operatingUnit:'',
        cooperationEndDate:'',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        countyCode: '',
        countyName: '',
        usePermissions: '',
        useTimePeriod: '',
        useTimePeriodStartTime: '',
        useTimePeriodEndTime: '',
        lamplight: '',
        grandstand: '',
        ancillaryFacilities: '',
        remark: '',
      },
      rest:false,
      quan:false,
      selectOrganList: [],
      selectCenterList: [],
      loading: false,
      addbtnLoading: false,
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      fileListChangedFlag: false,
      ops,
      footballType,
      propertyTypeList,
      uploadErroeMsg: "", // 文件上传信息校验
      uploadFileList: [], // 文件上传组件 - 文件列表
      uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件

    }
  },
  computed: {
    isShow: {
      get () {
        return this.addSquad
      },
      set (val) {
        this.$emit('update:addSquad', val)
      },
    },
    sh_county_list() {
      let arr = [];
      regions.forEach(item => {
        if(item.code == '31') {
          const { county, name } = item.city[0];
          arr = county
        }
      })
      return arr
    },
    // 时间选择器
    endPickerOptions() {
      const that = this;
      return {
        disabledDate(time) {
          if (that.squadInfo.cooperationStartDate) {
            return time.getTime() < that.squadInfo.cooperationStartDate;
          } else {
            return false;
          }
        },
      };
    },
    // 时间选择器
    StartPickerOptions() {
      const that = this;
      return {
        disabledDate(time) {
          if (that.squadInfo.cooperationEndDate) {
            return time.getTime() > that.squadInfo.cooperationEndDate;
          } else {
            return false;
          }
        },
      };
    },
  },
  watch: {


  },
  created () {
    if (this.squadUuid) {
      this.getSquadInfo()
    }else{
      this.setCityList();
    }
    this.$set(this.squadInfo, 'provinceCode', '31')
    this.changeProvince();
    this.getOrganListAndCenterList()
  },
  methods: {
    isXiuxi(){
      this.squadInfo.usePermissions ='';
      if(this.rest){
        this.squadInfo.usePermissions ='永久';
      }
      this.$refs['squadForm'].clearValidate();
    },
    quantian(){

      this.$set(this.squadInfo, 'useTimePeriodStartTime', '');
      this.$set(this.squadInfo, 'useTimePeriodEndTime', '');
      this.$set(this.squadInfo, 'useTimePeriod', '');
      if(this.quan){
        this.squadInfo.useTimePeriod ='全天';
      }
      this.$refs['squadForm'].clearValidate();
    },
    changeCityForYouthAdd () {
      this.squadInfo.cityName = this.cityList.find(item => {
        return item.code === this.squadInfo.cityCode
      }).name
    },
    changeCountyForYouthAdd() {
      this.squadInfo.countyName = this.sh_county_list.find(item => {
        return item.code === this.squadInfo.countyCode
      }).name || ''
    },
    // 文件上传超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多上传9个文件，本次上传已经超过了限制。`);
    },
    //  证明材料提交成功
    handleSuccessFiler(res, file) {
      if (this.uploadErroeMsg) this.uploadErroeMsg = "";
      this.fileListChangedFlag = true;
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        targetSecondlyUuid: this.targetUuid,
        stageUuid: this.stageUuid,
        fileType: suffix
      };
      if (this.isEdit) {
        this.uploadFileList_edit.push(fileObj);
      }
      this.uploadFileList.push(fileObj);
    },
    handleRemoveFile(file, fileList) {
      this.fileListChangedFlag = true;
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        this.uploadFileList = this.uploadFileList.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileList = this.uploadFileList.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }
      if(this.isEdit) {
        this.uploadFileList_edit = this.uploadFileList_edit.filter(item => {
          const  status = file.url !== item.url;
          return status
        })
      }
    },
    // 上传文件检测
    beforeUpload(file) {
       const fileReg = /^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i
       const fileType = fileReg.test(file.name)
      const fileLimit = file.size / 1024 / 1024 < 50;
      if (!fileLimit) {
        this.$message.error("单个上传文件大小不能超过50M");
        return false;
      }
       if (!fileType) {
         this.$message.error("请上传 jpg png pdf xlsx xls docx doc格式的文件");
         return false;
       }
      return fileLimit;
    },
    getOrganListAndCenterList () {
      let data = this.uuid
      let request
      if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
      } else if (this.userRole === 'system' || this.userRole === 'admin') {
        request = coach.getCenterListBySystem
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
      }
      request(data).then((res) => {
        this.selectOrganList = res
        if (this.selectOrganList.length === 1) {
          this.squadInfo.organUuid = this.selectOrganList[0].organUuid
          this.squadInfo.organShortName = this.selectOrganList[0].organShortName
          this.selectCenterList = this.selectOrganList[0].youthList || []
          if (this.selectCenterList.length === 1) {
            this.squadInfo.youthUuid = this.selectCenterList[0].uuid
            this.squadInfo.youthShortName = this.selectCenterList[0].youthShortName
          }
        }
      })
    },
    changeProvince () {
      this.regions.forEach(item => {
        if (item.code === this.squadInfo.provinceCode) {
          this.cityList = item.city
          this.$set(this.squadInfo, 'cityCode', this.cityList[0].code)
          this.$set(this.squadInfo, 'cityName', this.cityList[0].name)
          this.squadInfo.provinceName = item.name
        }
      })
    },
    getSquadInfo () {

      this.loading = true
      siteFacilities.getFootballInfo(this.squadUuid).then(res => {
        this.squadInfo = res.facilityFootball
        if(this.squadInfo.usePermissions ==='永久'){
          this.rest = true;
        }
        if(this.squadInfo.useTimePeriod ==='全天'){
          this.quan = true;
          this.$set(this.squadInfo, 'useTimePeriodStartTime', '');
          this.$set(this.squadInfo, 'useTimePeriodEndTime', '');
        }
        this.$set(this.squadInfo, 'countyCode', res.facilityFootball.countyCode === 0 ? '' : String(res.facilityFootball.countyCode));
        this.$set(this.squadInfo, 'cityCode', res.facilityFootball.cityCode === 0 ? '' : String(res.facilityFootball.cityCode));
        this.$set(this.squadInfo, 'provinceCode', res.facilityFootball.provinceCode === 0 ? '' : String(res.facilityFootball.provinceCode));

        if (res.contractList && res.contractList.length) {
          this.uploadFileList = [];
          this.uploadFileList = res.contractList.map((item) => {
            const { fileName, fileUrl } = item;
            return {
              ...item,
              name: fileName,
              url: fileUrl
            };
          });
        }
        this.setCityList();
        this.loading = false
      })
    },
    setCityList () {
      this.regions.forEach(item => {
        if (item.code === this.squadInfo.provinceCode) {
          this.cityList = item.city
        }
      })
    },
    addSquadCount () {
      if(this.uploadFileList.length === 0){
        this.$message.error("请上传相关合同文件")
        return
      }
      if(this.squadInfo.useTimePeriod === ''){
        if(!this.squadInfo.useTimePeriodStartTime || !this.squadInfo.useTimePeriodEndTime){
          this.$message.error("请选择使用时段")
          return
        }
      }
      this.$refs['squadForm'].validate(valid => {
        if (valid) {
          this.addbtnLoading = true
          let requestName = siteFacilities.addFootball
          let requestData = {
            facilityFootball : {
              ...this.squadInfo
            },
            contractList:this.uploadFileList
          }
          // 编辑球队时，data 加上 uuid，接口名改变
          if (this.isEdit) {
            requestName = siteFacilities.updataFootball
            requestData.facilityFootball.uuid = this.squadInfo.uuid
          }

          requestName(requestData).then(res => {
            this.addbtnLoading = false
            // 重复处理
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$emit('hideAddsquadDialog', false)

            }
          }).catch(err => {
            this.addbtnLoading = false
            console.error(err)
          })
        }
      })
    },
    changeCenter (youthUuid) {
      this.squadInfo.youthShortName = this.selectCenterList.find(item => {
        return item.uuid === this.squadInfo.youthUuid
      }).youthShortName
      if (youthUuid) {
        // this.getLeaderList(youthUuid)
        this.$set(this.squadInfo, 'chiefCoachUuid', '')
        this.$set(this.squadInfo, 'leaderUuid', '')
        this.$set(this.squadInfo, 'list', [{ coachUuid: '', duty: '', master: false }])
      }
    },


    changeOrg () {
      this.$set(this.squadInfo, 'youthUuid', '')
      this.$set(this.squadInfo, 'youthShortName', '')
      if (this.squadInfo.organUuid) {
        this.squadInfo.organShortName = this.selectOrganList.find(item => {
          return item.organUuid === this.squadInfo.organUuid
        }).organShortName
        this.selectCenterList = this.selectOrganList.find(item => {
          return item.organUuid === this.squadInfo.organUuid
        }).youthList || []
        if (this.selectCenterList.length === 1) {
          this.squadInfo.youthUuid = this.selectCenterList[0].uuid
          this.squadInfo.youthShortName = this.selectCenterList[0].youthShortName
        }
      } else {
        this.selectCenterList = []
      }
    },

  }
}
</script>

<style scoped lang="stylus">
  .tip
    color red
    width 100%
    margin-left: 50px;
    word-break break-word
  .yioks-form-item
    width 340px
  .provinceCenter
    display flex
    .label
      width: 140px;
      height 40px
      line-height 40px
      text-align center
      &:before
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
</style>
